<template>
	<router-view v-slot="{ Component }">
		<transition name="slide-up" mode="out-in">
			<div v-if="$route.name === 'rombel'" class="card">
				<div class="card-header">
					<span class="fs-5">Progres Kelengkapan Data Rinci Siswa</span>
				</div>
				<div class="card-body" v-loading="loading">
					<div class="row g-1 align-items-center justify-content-center">
						<span class="fs-5 col-auto text-center">
							<el-skeleton animated :loading="loading" :throttle="{ trailing: 250 }">
								<template #template>
									Persentase Kelangkapan
									<el-skeleton-item variant="text" style="width: 80px" />:
								</template>
								<template #default>Persentase Kelangkapan {{ namaRombel }}:</template>
							</el-skeleton>
						</span>
						<transition name="slide-up" mode="out-in">
							<span :key="progresRombelTotal" class="fs-4 col-auto" :class="progresRombelTotal.persen_total_class">{{ progresRombelTotal.persen_total || "-" }}%</span>
						</transition>
					</div>
					<hr />
					<el-table
						ref="tableProgresPerSiswa"
						:data="progresRombel"
						row-key="siswa_id"
						table-layout="auto"
						border
						stripe
						header-cell-class-name="text-center bg-light"
						@selection-change="changeSelection">
						<template #empty>
							<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
						</template>
						<el-table-column type="index" label="No." align="center" width="10" />
						<el-table-column prop="nis" label="NIS" align="center" />
						<el-table-column prop="nama_siswa" label="Nama" min-width="200px">
							<template #default="{ row }">
								<div class="hstack gap-1 justify-content-between">
									<span>{{ row.nama_siswa }}</span>
									<el-tooltip content="Lihat detail kelengkapan">
										<router-link :to="{ name: 'rombel-siswa-progres', params: { rombelId: $route.params.rombelId, siswaId: row.siswa_id } }">
											<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
										</router-link>
									</el-tooltip>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="Persentase Kelengkapan Data" align="center">
							<el-table-column prop="progres_detail_siswa" label="Detail Siswa" align="center" sortable label-class-name="small">
								<template #default="{ row }">
									<router-link
										:to="{ name: 'rombel-siswa-detail', params: { rombelId: $route.params.rombelId, siswaId: row.siswa_id } }"
										:class="row.progres_detail_siswa_class"
										:key="row.progres_detail_siswa"
										class="text-decoration-none">
										{{ row.progres_detail_siswa }}%
									</router-link>
								</template>
							</el-table-column>
							<el-table-column prop="progres_data_ayah" label="Data Ayah" align="center" sortable label-class-name="small">
								<template #default="{ row }">
									<router-link
										:to="{ name: 'rombel-siswa-data-ayah', params: { rombelId: $route.params.rombelId, siswaId: row.siswa_id } }"
										:class="row.progres_data_ayah_class"
										:key="row.progres_data_ayah"
										class="text-decoration-none">
										{{ row.progres_data_ayah }}%
									</router-link>
								</template>
							</el-table-column>
							<el-table-column prop="progres_data_ibu" label="Data Ibu" align="center" sortable label-class-name="small">
								<template #default="{ row }">
									<router-link
										:to="{ name: 'rombel-siswa-data-ibu', params: { rombelId: $route.params.rombelId, siswaId: row.siswa_id } }"
										:class="row.progres_data_ibu_class"
										:key="row.progres_data_ibu"
										class="text-decoration-none">
										{{ row.progres_data_ibu }}%
									</router-link>
								</template>
							</el-table-column>
							<el-table-column prop="progres_data_wali" label="Data Wali" align="center" sortable label-class-name="small">
								<template #default="{ row }">
									<router-link
										:to="{ name: 'rombel-siswa-data-wali', params: { rombelId: $route.params.rombelId, siswaId: row.siswa_id } }"
										:class="row.progres_data_wali_class"
										:key="row.progres_data_wali"
										class="text-decoration-none">
										{{ row.progres_data_wali }}%
									</router-link>
								</template>
							</el-table-column>
							<el-table-column prop="progres_total" label="Total" align="center" sortable label-class-name="small" class-name="fw-bold">
								<template #default="{ row }">
									<span :class="row.progres_total_class" :key="row.progres_total">{{ row.progres_total }}%</span>
								</template>
							</el-table-column>
							<el-table-column prop="last_update" label="Status" align="center" label-class-name="small">
								<template #default="{ row }">
									<div class="hstack gap-1 justify-content-center">
										<el-tooltip>
											<template #content>
												Terakhir diperbarui:<br />
												{{ row.last_update_styled }}
											</template>
											<el-icon><i class="bi bi-info-circle"></i></el-icon>
										</el-tooltip>
										<div class="vr"></div>
										<el-tooltip :content="row.kunci_data ? `Akses edit terkunci` : `Akses edit terbuka`">
											<el-icon v-if="row.kunci_data" class="text-secondary"><Lock /></el-icon>
											<el-icon v-else class="text-success"><Unlock /></el-icon>
										</el-tooltip>
									</div>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column align="center" v-if="isPengelola">
							<template #header>
								Akses Edit
								<transition name="fade" mode="out-in">
									<div class="small" v-if="lockedSelected.length || unlockedSelected.length">
										Ubah akses edit data terpilih<br />
										<el-button-group size="small">
											<el-button type="info" v-if="unlockedSelected.length" :loading="locking" @click="kunciAksesEdit">Kunci</el-button>
											<el-button type="primary" v-if="lockedSelected.length" :loading="unlocking" @click="bukaAksesEdit">Buka</el-button>
										</el-button-group>
									</div>
								</transition>
							</template>
							<el-table-column prop="kunci_data" label="Tindakan" align="center" label-class-name="small">
								<template #default="{ row }">
									<el-popconfirm
										width="240px"
										:title="row.kunci_data ? `Buka akses pengeditan data ${row.nama_siswa}?` : `Tutup akses pengeditan data ${row.nama_siswa}?`"
										confirm-button-type="success"
										@confirm="gantiStatusKunciData(row, true)"
										@cancel="gantiStatusKunciData(row, false)">
										<template #reference>
											<transition name="fade" mode="out-in">
												<el-button :key="row.kunci_data" :type="row.kunci_data ? 'primary' : 'info'" size="small" :loading="row.loading" round plain>
													{{ row.kunci_data ? "Buka" : "Kunci" }}
												</el-button>
											</transition>
										</template>
									</el-popconfirm>
								</template>
							</el-table-column>
							<el-table-column type="selection" align="center" />
						</el-table-column>
					</el-table>
				</div>
			</div>
			<component :is="Component" v-else />
		</transition>
	</router-view>
</template>

<script>
export default {
	name: "RombelView",
	data() {
		return {
			progresRombelTotal: {},
			progresRombel: [],
			loading: false,
			locking: false,
			unlocking: false,
			lockedSelected: [],
			unlockedSelected: [],
			updatedProgresSiswa: async (data) => {
				const d = JSON.parse(data);
				const row = this.progresRombel.find((s) => s.siswa_id === d.siswa_id);
				if (row) {
					this.getPersentaseRombelTotal();
					const progres = await this.getProgresDataSiswa(row.siswa_id);
					if (progres) {
						row.progres_detail_siswa_class = row.progres_detail_siswa !== progres.progres_detail_siswa ? "highlighted " : "";
						row.progres_data_ayah_class = row.progres_data_ayah !== progres.progres_data_ayah ? "highlighted " : "";
						row.progres_data_ibu_class = row.progres_data_ibu !== progres.progres_data_ibu ? "highlighted " : "";
						row.progres_data_wali_class = row.progres_data_wali !== progres.progres_data_wali ? "highlighted " : "";

						row.progres_detail_siswa = progres.progres_detail_siswa;
						row.progres_data_ayah = progres.progres_data_ayah;
						row.progres_data_ibu = progres.progres_data_ibu;
						row.progres_data_wali = progres.progres_data_wali;
						row.progres_total = progres.progres_total;
						row.last_update = progres.last_update;
						row.last_update_styled = new Date(progres.last_update).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "long" });

						row.progres_detail_siswa_class += this.getTextStyle(progres.progres_detail_siswa);
						row.progres_data_ayah_class += this.getTextStyle(progres.progres_data_ayah);
						row.progres_data_ibu_class += this.getTextStyle(progres.progres_data_ibu);
						row.progres_data_wali_class += this.getTextStyle(progres.progres_data_wali);
						row.progres_total_class = this.getTextStyle(progres.progres_total) + " highlighted";

						setTimeout(() => {
							row.progres_detail_siswa_class = this.getTextStyle(progres.progres_detail_siswa);
							row.progres_data_ayah_class = this.getTextStyle(progres.progres_data_ayah);
							row.progres_data_ibu_class = this.getTextStyle(progres.progres_data_ibu);
							row.progres_data_wali_class = this.getTextStyle(progres.progres_data_wali);
							row.progres_total_class = this.getTextStyle(progres.progres_total);
						}, 600);
					}
				}
			},
			changedKunciDataSiswa: (data) => {
				const d = JSON.parse(data);
				const siswaIds = d.siswa_ids || [];

				const table = this.$refs.tableProgresPerSiswa;
				for (const pr of this.progresRombel) {
					if (siswaIds.includes(pr.siswa_id)) {
						pr.kunci_data = d.kunci_data;
						table.toggleRowSelection(pr, false);
					}
				}
			},
		};
	},
	components: {},
	computed: {
		isPengelola() {
			const roles = this.$store.getters.getRoles;
			return roles?.some((r) => ["dev", "superadmin", "admin-kesiswaan", "pengelola"].includes(r.role));
		},
		namaRombel() {
			const rombelStatus = this.$store.getters["rombel/getStatusById"](this.$route.params.rombelId);
			const rombel = this.$store.getters["rombel/getDataById"](this.$route.params.rombelId);
			if (rombelStatus === "success") return rombel.nama;
			return "Rombel";
		},
	},
	watch: {
		"$route.params.rombelId": {
			immediate: true,
			handler(id) {
				if (!id) return;
				this.$store.dispatch("rombel/fetchData", id);
				this.getPersentaseRombelTotal();
				this.getPersentaseRombel();
			},
		},
	},
	mounted() {
		this.$ws.main.on("detail-siswa:updated", this.updatedProgresSiswa);
		this.$ws.main.on("data-ayah:updated", this.updatedProgresSiswa);
		this.$ws.main.on("data-ibu:updated", this.updatedProgresSiswa);
		this.$ws.main.on("data-wali:updated", this.updatedProgresSiswa);
		this.$ws.main.on("kunci-data:changed", this.changedKunciDataSiswa);
	},
	beforeUnmount() {
		this.$ws.main.off("detail-siswa:updated");
		this.$ws.main.off("data-ayah:updated");
		this.$ws.main.off("data-ibu:updated");
		this.$ws.main.off("data-wali:updated");
		this.$ws.main.off("kunci-data:changed");
	},
	methods: {
		changeSelection(val) {
			this.lockedSelected = val.filter((r) => r.kunci_data === 1).map((f) => f.siswa_id);
			this.unlockedSelected = val.filter((r) => r.kunci_data === 0).map((f) => f.siswa_id);
		},
		async getPersentaseRombelTotal() {
			try {
				const { data } = await this.$defaultApi.post("/progres/rombel/total", {
					rombel_id: this.$route.params.rombelId,
				});

				const result = data.progres_rombel || {};
				result.persen_total = result.persen_total?.toFixed(2) || 0;
				result.persen_total_class = this.getTextStyle(result.persen_total);

				this.progresRombelTotal = result;
			} catch (error) {
				console.error(error);
				return null;
			}
		},
		async getPersentaseRombel() {
			this.loading = true;
			try {
				const { data } = await this.$defaultApi.post("/progres/rombel", {
					rombel_id: this.$route.params.rombelId,
				});

				const result = data.progres_rombel || [];
				result.forEach((r) => {
					r.progres_detail_siswa_class = this.getTextStyle(r.progres_detail_siswa);
					r.progres_data_ayah_class = this.getTextStyle(r.progres_data_ayah);
					r.progres_data_ibu_class = this.getTextStyle(r.progres_data_ibu);
					r.progres_data_wali_class = this.getTextStyle(r.progres_data_wali);
					r.progres_total_class = this.getTextStyle(r.progres_total);

					r.last_update_styled = new Date(r.last_update).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "long" });
					r.loading = false;
				});

				this.progresRombel = result;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				setTimeout(() => {
					this.loading = false;
				}, 500);
			}
		},
		async getProgresDataSiswa(siswaId) {
			try {
				const { data } = await this.$defaultApi.post("/progres/siswa", {
					siswa_id: siswaId,
				});

				return data.progres_siswa;
			} catch (error) {
				console.error(error);
				return null;
			}
		},
		async gantiStatusKunciData(siswa, confirmed) {
			if (confirmed) {
				siswa.loading = true;
				try {
					await this.$defaultApi.post("/progres/kunci-data", {
						kunci_data: siswa.kunci_data === 0 ? 1 : 0,
						siswa_ids: [siswa.siswa_id],
					});
					this.$notify.success({
						title: "Berhasil",
						message: `Berhasil ${siswa.kunci_data ? "mengunci" : "membuka"} akses edit ${siswa.nama_siswa}`,
					});
				} catch (error) {
					if (error.response) {
						console.error(error.response.data.errMessage);
						return this.$notify.error({
							title: error.response.data.error || "Gagal",
							message: error.response.data.message,
						});
					}

					console.error(error);
				} finally {
					setTimeout(() => {
						siswa.loading = false;
					}, 500);
				}
			}
		},
		async kunciAksesEdit() {
			if (!this.unlockedSelected.length) {
				return this.$notify.warning({
					title: "Perhatian",
					message: "Tidak ada data terpilih dengan status akses edit terbuka",
				});
			}

			this.locking = true;
			try {
				const { data } = await this.$defaultApi.post("/progres/kunci-data", {
					kunci_data: 1,
					siswa_ids: this.unlockedSelected,
				});

				const table = this.$refs.tableProgresPerSiswa;
				this.unlockedSelected.forEach((id) => {
					const row = this.progresRombel.find((r) => r.siswa_id === id);
					if (row) table.toggleRowSelection(row, false);
				});

				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
			} finally {
				setTimeout(() => {
					this.locking = false;
				}, 500);
			}
		},
		async bukaAksesEdit() {
			if (!this.lockedSelected.length) {
				return this.$notify.warning({
					title: "Perhatian",
					message: "Tidak ada data terpilih dengan status akses edit tertutup",
				});
			}

			this.unlocking = true;
			try {
				const { data } = await this.$defaultApi.post("/progres/kunci-data", {
					kunci_data: 0,
					siswa_ids: this.lockedSelected,
				});

				const table = this.$refs.tableProgresPerSiswa;
				this.lockedSelected.forEach((id) => {
					const row = this.progresRombel.find((r) => r.siswa_id === id);
					if (row) table.toggleRowSelection(row, false);
				});

				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
			} finally {
				setTimeout(() => {
					this.unlocking = false;
				}, 500);
			}
		},
		getTextStyle(val) {
			if (val > 85) return "text-success";
			if (val > 65) return "text-success-emphasis";
			if (val > 35) return "text-warning";
			return "text-danger";
		},
	},
};
</script>

<style scoped></style>
